import { ComponentElement } from './stores/componentManager';
import Split from './webcomponents/split';
import Progress from './webcomponents/progress';
import Figure from './webcomponents/figure';
import 'img-comparison-slider';
// import Compare from './webcomponents/compare';
import Select from './webcomponents/select';

export default async function () {
  // customElements.define('c-modal', ComponentElement(Modal, 'Modal'));
  // customElements.define('c-carousel', ComponentElement(Carousel, 'Carousel'));
  // customElements.define('c-accordion', ComponentElement(Accordion, 'Accordion'));
  customElements.define('c-split', ComponentElement(Split, 'Split'));
  customElements.define('c-progress', ComponentElement(Progress, 'Progress'));
  customElements.define('c-figure', ComponentElement(Figure, 'Figure'));
  customElements.define('c-select', ComponentElement(Select, 'Select'));
  // customElements.define('c-dropdown', ComponentElement(Dropdown, 'Dropdown'));
  // customElements.define('c-accordion-group', ComponentElement(AccordionGroup, 'AccordionGroup'));
}
